import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getGameDetails } from '../apiservices/LocalStorageService';
import { sseManager } from '../sse';

const PlayerRouteGuard: React.FC = () => {
  const gameDetails = getGameDetails();

  useEffect(() => {
    return () => {
      sseManager.close();
    };
  }, []);

  if (!gameDetails?.gameId || !gameDetails?.playerId) {
    return <Navigate to="/join" replace />;
  }

  return <Outlet />;
};

export default PlayerRouteGuard;
